module.exports = __webpack_public_path__ + "static/media/gif_rascunho_cds.2afd40bc.gif";